import React, { useEffect, useState } from "react";
import Breadcrumb, { BreadcrumbLink } from "../../../components/breadcrumbs";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import EventCard from "components/cards/event-card";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import useHost from "../useHooks";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useStore from "hooks/useStore";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import EventRatingNotFoundGif from "assets/images/gifs/rated-events-not-found.gif";


const MyRating = () => {
  const navigate = useNavigate();
  const { isProfileCompleted } = useStore();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<EventDTO[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const { getHostRatedEvents } = useHost();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.home, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  useEffect(() => {
    getHostRatedEvents(setData);
  }, []);

  // Mark initial load as complete when loading finishes
  useEffect(() => {
    if (isInitialLoad && !isLoading) {
      setIsInitialLoad(false);
    }
  }, [isLoading, isInitialLoad]);


  const breadcrumbLinks: BreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.home },
    { title: "My Ratings", path: siteRoutes.myRating },
  ];




  return (
    <div className="container min-h-screen">
      <Breadcrumb links={breadcrumbLinks} />
      <h2 className="text-2xl font-bold mb-4">My Ratings</h2>
    
      {/* Experiences */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-6">
        {data.length > 0
          ? data.map((event) => (
            <EventCard event={event} key={event.id} />
            ))
          : null}
      </div>

      <CustomMessageDisplay
        show={!isLoading && !data.length && !isInitialLoad}
        title="No Rated Events Available"
        slogan="You haven't rated any events yet. Rated events will appear here once you provide feedback on your experiences."
        image={EventRatingNotFoundGif}
        imageAlt="No rated events found"
        className="py-12"
        imageClassName="w-[150px] h-[120px]"
        titleClassName="text-2xl font-bold text-blackie"
        sloganClassName="text-gray-500 text-base"
      />

    </div>
  );
};

export default MyRating;
